<template>
  <div class="boot" :style="containerstyle">
    <canvas id="waterfall" style="position: absolute;"></canvas>
    <div class="bj" style="z-index: 99;">
      <div class="header">
        <div class="headerLeft">
          <span>{{ dateYear }}</span>
          <div>{{ dateWeek }}</div>
        </div>
        <div class="title">
          <span class="hz">平安堆龙社会治理信息化管理平台</span>
          <span class="zw">དུས་བདེའི་སྟོད་ལུང་སྤྱི་ཚོགས་བཅོས་སྐྱོང་ཆ་འཕྲིན་ཅན་གྱི་དོ་དམ་ལས་སྟེགས་ </span>
        </div>
        <div class="headerRight" :style="isLogout?'opacity: 0;':'opacity: 1;'" @click="logout">
          退出登录
        </div>
      </div>
      <div class="content">
        <div class="rotate-tag">
          <template v-for="(item, index) in routes" >
            <div :key="index" v-if="!item.hidden"
              ref="routesRef"
              :style="isStopAnimation ? 'animation-play-state: paused' : 'animation-play-state: running'"
              :class="index % 3 == 0 ? 'tag good' : index % 3 === 1 ? 'tag bad' : 'tag normal'"
              @mouseenter="itemMouse('enter')" @mouseleave="itemMouse('leave')">
              <!-- <div class="infoBox" @click="$router.push(resolvePath(item))"> -->
              <div class="infoBox" @click="handleSelect(item)">
                <!-- 图标 -->
                <i class="icon" v-if="item.meta.icon && item.meta.icon.indexOf('.')==-1" :class="item.meta ?  item.meta.icon : item.children[0].meta.icon" alt=""></i>
                <!-- 图片 -->
                <img class="icon" v-else :src="item.meta ? imageUrlprefix + item.meta.icon : imageUrlprefix + item.children[0].meta.icon" alt="">
                <span class="title">{{ item.meta ? item.meta.title : item.children[0].meta.title }}</span>
                <img class="kuang" src="@/assets/images/boot/kuang1.png" alt="">
                <img class="dz" src="@/assets/images/boot/dz.png" alt="">

                <div class="infoLeft">
                  <div class="infoLeftItem" v-for="(ele, idx) in item.leftList" :key="idx" @click.stop="handleChildSelect(item,ele)">
                    {{ ele.meta.title }}
                    <img class="lineLeft" v-if="ele.icon" :src="ele.icon" alt="">
                  </div>
                </div>
                <div class="infoRight">
                  <div class="infoLeftItem" v-for="(ele, idx) in item.rightList" :key="idx" @click.stop="handleChildSelect(item,ele)">
                    {{ ele.meta.title }}
                    <img class="lineRight" v-if="ele.icon" :src="ele.icon" alt="">
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="inner-Img">
          <img class="contentIcon" @click="$router.push('/index')" src="@/assets/images/boot/contentIcon.png" alt="">
          <div class="roundBox">
            <!-- <img src="@/assets/images/boot/all.png" class="outCircle" /> -->
            <!-- <img src={inner} class="circle" /> -->
            <img src="@/assets/images/boot/round1.png" alt="">
            <img src="@/assets/images/boot/round2.png" alt="">
            <img src="@/assets/images/boot/round3.png" alt="">
            <img src="@/assets/images/boot/round4.png" alt="">
            <img src="@/assets/images/boot/round5.png" alt="">

            <img src="@/assets/images/boot/round6.png" alt="">
            <img src="@/assets/images/boot/round7.png" alt="">
            <img src="@/assets/images/boot/round8.png" alt="">
            <img src="@/assets/images/boot/round9.png" alt="">
            <img src="@/assets/images/boot/round10.png" alt="">
          </div>
        </div>
      </div>
    </div>


    <!-- 登录 -->
      <div v-if="isLogin && isLogout" class="loginDialog">
        <loginContainer v-if="isLogin" :isClose="true" @close="closeLoginDialog"></loginContainer>
      </div>
  </div>
</template>

<script>
import {formatTime1} from '../../utils/index.js'
import {getToken} from '@/utils/auth'
import loginContainer from '@/views/login/components/loginContainer.vue'
export default {
  components:{
    loginContainer,
  },
  data() {
    return {
      isLogout:false,//是否退出登录
      isLogin:false,//是否登录
      routes: [],//接口获取路由
      isStopAnimation: false,
      containerstyle: {},
      list: [
        {
          name: "政治引领",
          icon: require('@/assets/images/boot/icon-zzyl.png'),
          leftList: [
            {
              name: '基层党建',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
            {
              name: '行政组织',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
          ],
          rightList: [
            {
              name: '社会组织',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
            {
              name: '综治队伍',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
          ],
          child: [
            {
              name: '基层党建',
              page: '',
            },
            {
              name: '社会组织',
              page: '',
            },
            {
              name: '行政组织',
              page: '',
            },
            {
              name: '综治队伍',
              page: '',
            },
          ],
        },
        {
          name: "自治基础",
          icon: require('@/assets/images/boot/icon-jcfw.png'),
          leftList: [
            {
              name: '基础搜索',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
            {
              name: '基层服务',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
          ],
          rightList: [
            {
              name: '风险排查',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
            {
              name: '自我化解',
              icon: require('@/assets/images/boot/leftContentLine.png'),
              page: '',
            },
            {
              name: '工作动态',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
          ],
          child: [
            {
              name: '基础搜索',
              page: '',
            },
            {
              name: '风险排查',
              page: '',
            },
            {
              name: '基层服务',
              page: '',
            },
            {
              name: '自我化解',
              page: '',
            },
            {
              name: '工作动态',
              page: '',
            },
          ],
        },
        {
          name: "智治支撑",
          icon: require('@/assets/images/boot/icon-zzzc.png'),
          num: 1,
          leftList: [
            {
              name: '指挥调度',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
            {
              name: '视频监控',
              icon: require('@/assets/images/boot/leftContentLine.png'),
              page: '',
            },
            {
              name: '人员核查',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
          ],
          rightList: [
            {
              name: '辅助工具',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
            {
              name: '预警中心',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
          ],
          child: [
            {
              name: '指挥调度',
              page: '',
            },
            {
              name: '辅助工具',
              page: '',
            },
            {
              name: '视频监控',
              page: '',
            },
            {
              name: '预警中心',
              page: '',
            },
            {
              name: '人员核查',
              page: '',
            },
          ],
        },
        {
          name: "德治教化",
          icon: require('@/assets/images/boot/icon-dzjh.png'),
          num: 1,
          leftList: [
            {
              name: '宣传引导',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
            {
              name: '综合考评',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
          ],
          rightList: [
            {
              name: '好人好事',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
            {
              name: '系统管理',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
          ],
          child: [
            {
              name: '宣传引导',
              page: '',
            },
            {
              name: '好人好事',
              page: '',
            },
            {
              name: '综合考评',
              page: '',
            },
            {
              name: '系统管理',
              page: '',
            },
          ],
        },
        {
          name: "法制保障",
          icon: require('@/assets/images/boot/icon-fzbz.png'),
          num: 1,
          leftList: [
            {
              name: '矛盾纠纷',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
            {
              name: '案事件',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
          ],
          rightList: [
            {
              name: '案件线索',
              icon: require('@/assets/images/boot/leftBottomLine.png'),
              page: '',
            },
            {
              name: '法制宣传',
              icon: require('@/assets/images/boot/leftTopLine.png'),
              page: '',
            },
          ],
          child: [
            {
              name: '矛盾纠纷',
              page: '',
            },
            {
              name: '案件线索',
              page: '',
            },
            {
              name: '案事件',
              page: '',
            },
            {
              name: '法制宣传',
              page: '',
            },
          ],
        },
      ],
      timing: null,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    }
  },
  mounted() {
    // var waterfall = document.getElementById("waterfall");
    // var ctx = waterfall.getContext("2d");
    // waterfall.width = 1920;
    // waterfall.height = 1080;
    // var chinese = "平安堆龙社会治理信息化管理平台";
    // chinese = chinese.split("");
    // var font_size = 10;
    // var columns = waterfall.width / font_size;
    // var drops = [];
    // for (var x = 0; x < columns; x++) drops[x] = 1;
    // function draw() {
    //   ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
    //   ctx.fillRect(0, 0, waterfall.width, waterfall.height);
    //   ctx.fillStyle = "#0e5acc";
    //   ctx.font = font_size + "px arial";
    //   var bgImg = new Image();
    //   bgImg.src = '@/assets/images/boot/bj.png';
    //   // 加载背景图片
    //   bgImg.onload = function(){
    //   // 绘制背景图片
    //   ctx.drawImage(bgImg, 0, 0, waterfall.width , waterfall.height);
    //   }
    //   for (var i = 0; i < drops.length; i++) {
    //     var text = chinese[Math.floor(Math.random() * chinese.length)];
    //     ctx.fillText(text, i * font_size, drops[i] * font_size);
    //     if (drops[i] * font_size > waterfall.height && Math.random() > 0.975)
    //       drops[i] = 0;
    //     drops[i]++;
    //   }
    // }
    // setInterval(draw, 50);

    this.timeFn()
    this.setautoSize()
    //窗口变动自动适配分辨率
    window.onresize = () => {
      //调用methods中的事件
      this.setautoSize()
    }
	this.$nextTick(()=>{
	   //    let routes = this.$refs.routesRef;
		  // const numadd = 20.4 / (routes.length - 1);
	   //    for (let index = 0; index < routes.length; index++) {
	   //      const element = routes[index];
	   //      element.setAttribute("style", `animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) ${-6 - numadd * index}s infinite alternate,
	   //        animY 12s cubic-bezier(0.36, 0, 0.64, 1) ${0 - numadd * index}s infinite alternate,
	   //        scale 24s cubic-bezier(0.36, 0, 0.64, 1) ${0 - numadd * index}s infinite alternate;
	   //      `);
	   //    }
	   let routes = this.$refs.routesRef;
	   const numadd = 40.8 / (routes.length - 1);
	   for (let index = 0; index < routes.length; index++) {
	     const element = routes[index];
	     element.setAttribute("style", `animation: animX 24s cubic-bezier(0.36, 0, 0.64, 1) ${-12 - numadd * index}s infinite alternate,
	       animY 24s cubic-bezier(0.36, 0, 0.64, 1) ${0 - numadd * index}s infinite alternate,
	       scale 48s cubic-bezier(0.36, 0, 0.64, 1) ${0 - numadd * index}s infinite alternate;
	     `);
	   }
	  })
  },
  created() {
    let addRoutes = []
    this.isLogout = localStorage.getItem('isLogout')=='true'//是否退出登录 true是 false否
    if(localStorage.getItem('isLoginDialog')=='true'){
      this.isLogin = true;
      localStorage.setItem('isLoginDialog',false)
    }
    if(!getToken()){//未登录
      addRoutes = [
        {
          path: "/zzyl",
          hidden: false,
          meta: {
            title: "政治引领",
            "icon": "/sys/file/stream/icon/20231124/1727993484696092672.png",
            menuType: 1,
            pageParam: null
          },
          children:[]
        },
        {
          path: "/fzbz",
          hidden: false,
          meta: {
            title: "法治保障",
            "icon": "/sys/file/stream/icon/20231124/1727993544980824064.png",
            menuType: 1,
            pageParam: null
          },
        },
        {
          path: "/zzjc",
          hidden: false,
          meta: {
            title: "自治基础",
            icon: "/sys/file/stream/icon/20231124/1727994893843824640.png",
            menuType: 1,
            pageParam: null
          },
        },
        {
          path: "/zzzc",
          hidden: false,
          meta: {
            title: "智治支撑",
            icon: "/sys/file/stream/icon/20231124/1727993688711233536.png",
            menuType: 1,
            pageParam: null
          },
        },
        {
          path: "/dzjh",
          hidden: false,
          meta: {
            title: "德治教化",
            icon: "/sys/file/stream/icon/20231124/1727993727269470208.png",
            menuType: 1,
            pageParam: null
          },
        }
      ]
    }else{
      addRoutes = JSON.parse(JSON.stringify(this.$store.state.route.addRoutes))
    }
    console.log(addRoutes,'addRoutes');
    
    this.routes = addRoutes.map((item,index) => {
      if (item.name == 'Index' || item.name == 'index' || item.path == '/') {
        item.meta = item.children[0].meta
      }
      if(item.children && Array.isArray(item.children) && item.children.length){
        if(!item.leftList){
          this.$set(item,'leftList',[])
        }
        if(!item.rightList){
          this.$set(item,'rightList',[])
        }
        item.children.forEach((ele,idx) => {
          if (idx % 2 === 0) {  // 下标为偶数
            item.leftList.push(ele);
          } else {  // 下标为奇数
            item.rightList.push(ele);
          }
        });
      }
      return {
        ...item,
      }
    })
  },

  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    // 关闭登录弹窗
    closeLoginDialog(){
      this.isLogin = false;
      localStorage.setItem('isLoginDialog',false)
    },
    handleSelect(item) {
      // 把选中路由的子路由保存store
      localStorage.setItem('routeItem',JSON.stringify(item))//保存一级路由
      this.$router.push(this.resolvePath(item));//跳转第一个子路由页面
    },
    handleChildSelect(item,ele){
      this.$router.push(item.path + '/' + this.resolvePath(ele));//跳转第一个子路由页面
      localStorage.setItem('routeItem',JSON.stringify(item))//保存一级路由
      this.$store.commit('SET_CURRENT_ROUTES', ele)//保存二级路由
    },
    //匹配路由路径
    resolvePath(item) {
      // 如果是首页，就返回重定向路由
      if (item.path === '/') {
        const path = '/index'
        return path
      }
      // 如果有子项，默认跳转第一个子项路由
      let path = ''
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 第一次需要父项路由拼接，所以只是第一个传parent
        if (parent) {
          path += (parent.path + '/' + item.path)
        } else {
          path += ('/' + item.path)
        }
        // 如果还有子项，继续递归
        if (item.children) {
          getDefaultPath(item.children[0])
        }
      }

      if (item.children) {
        getDefaultPath(item.children[0], item)
        return path
      }

      return item.path
    },
    //鼠标移入停止动画
    itemMouse(type) {
      if (type == 'enter') {
        this.isStopAnimation = true;
      } else if (type == 'leave') {
        this.isStopAnimation = false;
      }
    },
    //退出登录
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push("/login")
        localStorage.setItem('isLogout',true)
        this.$message.success('退出登录成功！')
      })
    },
    setautoSize() {
      this.containerstyle = `transform:scale(${window.innerWidth / 1920},${window.innerHeight / 1080});overflow: hidden; width: 1920px;transform-origin: left top 0px;`
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime1(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime1(new Date(), 'yyyy年MM月dd日')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
  },
}
</script>

<style>
@keyframes animX {
  0% {
    left: -4%;
  }

  100% {
    left: 92%;
  }
}


@keyframes animY {
  0% {
    top: -30%;
  }

  100% {
    top: 94%;
  }
}

 @keyframes scale {
  0% {
    transform: scale(0.2);
    opacity: 0.7;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(0.2);
    opacity: 0.7;
  }
}
</style>
<style lang="scss" scoped>
.boot {
  position: relative;
  background: #0F203E;
  height: 1080px;

  .bj {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/boot/bj.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    .header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      height: 93.5px;
      background-image: url('../../assets/images/boot/headerBj.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .title {
        display: flex;
        flex-direction: column;
        text-align: center;
        font-family: 'AlimamaShuHeiTi-Bold';
        font-weight: bold;
        font-size: 35px;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: -webkit-linear-gradient(bottom, #b4cdff 50%, #ffffff 100%);

        .hz {
          // margin: 3px 0 1px 0;
          letter-spacing: 1px;
        }

        .zw {
          color: #b4cdff;
          font-size: 18px;
          letter-spacing: 4px;
        }
      }

      .headerLeft {
        margin-left: 16px;
        margin-top: 16px;
        display: flex;
        align-items: center;

        span {
          font-size: 16px;
          font-family: 'AlimamaShuHeiTi-Bold';
          font-weight: bold;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-image: -webkit-linear-gradient(bottom, #b4cdff 50%, #ffffff 100%);
        }

        div {
          margin-top: 6px;
          margin-left: 33px;
          font-family: 'AlimamaShuHeiTi-Bold';
          font-weight: bold;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-image: -webkit-linear-gradient(bottom, #b4cdff 50%, #ffffff 100%);
        }
      }

      .headerRight {
        cursor: pointer;
        width: 204.53px;
        text-align: right;
        margin-right: 16px;
        font-size: 16px;
        margin-top: 16px;
        font-family: 'AlimamaShuHeiTi-Bold';
        font-weight: bold;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: -webkit-linear-gradient(bottom, #b4cdff 50%, #ffffff 100%);
      }


    }

    .content {
      flex: 1;
      position: relative;

      .rotate-tag {
        position: absolute;
        z-index: 9999;
        top: 35%;
        left: 48%;
        transform: translateX(-50%);
        width: 78%;
        // height: 40vh;
        height: 38.5%;

        .infoBox {
          cursor: pointer;
          position: relative;
          width: 211.5px;
          height: 280px;

          .icon {
            position: absolute;
            left: 50%;
            top: 0;
            z-index: 998;
            transform: translateX(-50%);
            width: 97.9px;
            height: 125.2px;
            animation: iconDownUp 1.5s linear infinite alternate;
            font-size: 97.9px;

            background-image:-webkit-linear-gradient(bottom,#52B4FB,#4F98ED,#C2E3FC);
            -webkit-background-clip:text;
            -webkit-text-fill-color:transparent;
          }

          @keyframes iconDownUp {
            0% {
              top: -1%;
            }

            100% {
              top: 6%;
            }
          }

          .title {
            position: absolute;
            z-index: 999;
            width: 100%;
            text-align: center;
            top: 50%;
            left: 0%;
            transform: translateY(-50%);
            font-size: 32px;
            color: #ffffff;
            animation: titleDownUp 1.5s linear infinite alternate;
          }

          @keyframes titleDownUp {
            0% {
              top: 48%;
            }

            100% {
              top: 56%;
            }
          }

          .kuang {
            width: 100%;
            position: absolute;
            z-index: 999;
            left: 0;
            animation: kuangDownUp 2s linear infinite;
          }

          @keyframes kuangDownUp {
            0% {
              bottom: 180px;
            }

            100% {
              bottom: 52px;
            }
          }

          .dz {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
          }

          &:hover .infoLeft {
            transition: all 1s linear;
            opacity: 1;
          }

          &:hover .infoRight {
            transition: all 1s linear;
            opacity: 1;
          }


          .infoLeft,
          .infoRight {
            opacity: 0;
            position: absolute;
            // background: red;
            left: -90%;

            .infoLeftItem {
              width: 209.1px;
              height: 51.6px;
              background-image: url('../../assets/images/boot/nameBj.png');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 209.1px 51.6px;
              text-align: center;
              line-height: 51.6px;
              color: #effeff;
              font-size: 24px;
            }
          }

          .infoRight {
            left: auto;
            right: -180px;

          }

          .lineLeft {
            width: 48px;
            height: 48px;
            position: absolute;
            // background: red;
            left: 90%;
          }

          .lineRight {
            width: 48px;
            height: 48px;
            position: absolute;
            // background: red;
            right: 193px;
          }
        }

      }

      .tag {
        width: 300px;
        height: 180px;
        // line-height: 48px;
        // .backgroundImg('~static/images/pannel/jcsj/normal.png');

        z-index: 3;
        background-position: center;
        background-repeat: no-repeat;
        text-align: center;
        border-radius: 50%;
        position: absolute;

        &.bad {
          // .backgroundImg('~static/images/pannel/jcsj/bad.png');
        }

        &.good {
          // .backgroundImg('~static/images/pannel/jcsj/good.png');
        }



        .title {
          position: absolute;
          text-align: left;
          top: 40px;
          left: 60px;
          font-size: 40px;
          width: 200%;
        }

        // &:nth-child(1) {
        //   // left: 20%;
        //   // top: 90%;
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -6s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) 0s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) 0s infinite alternate;
        // }

        // &:nth-child(2) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -9.4s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -3.4s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -3.4s infinite alternate;
        // }

        // &:nth-child(3) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -12.8s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -6.8s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -6.8s infinite alternate;
        // }

        // &:nth-child(4) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -16.2s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -10.2s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -10.2s infinite alternate;
        // }

        // &:nth-child(5) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -19.6s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -13.6s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -13.6s infinite alternate;
        // }

        // &:nth-child(6) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -23s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -17s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -17s infinite alternate;
        // }

        // &:nth-child(7) {
        //   animation: animX 12s cubic-bezier(0.36, 0, 0.64, 1) -26.4s infinite alternate,
        //     animY 12s cubic-bezier(0.36, 0, 0.64, 1) -20.4s infinite alternate,
        //     scale 24s cubic-bezier(0.36, 0, 0.64, 1) -20.4s infinite alternate;
        // }


      }

      // }

      .inner-Img {
        height: 100%;
        position: absolute;
        left: 50%;

        // background-size: auto 100%;
        // position: relative;
        // text-align: center;
        .contentIcon {
          cursor: pointer;
          position: absolute;
          // top: 18%;
          left: 50%;
          z-index: 9999;
          transform: translate(-57%, 8px) scale(0.9);
          width: 620px;
          height: 554px;
          animation: contentIcondownUp 3s linear infinite alternate;
        }

        @keyframes contentIcondownUp {
          0% {
            top: 6%;
          }

          100% {
            top: 18%;
          }
        }

        .roundBox {
          position: relative;
          // transform: rotateX(114deg) translateY(4%);
          transform: rotateX(114deg) translateY(8%);
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            position: absolute;
          }

          :nth-child(1) {
            width: 1028px;
            height: 1028px;
            // width: 120vw;
            // background: red;
            border-radius: 50%;
            animation: range1 6s linear infinite;
          }

          @keyframes range1 {
            from {
              transform: translateY(-66%) scale(2.3) rotate(0);
            }

            to {
              transform: translateY(-66%) scale(2.3) rotate(360deg);
            }
          }

          :nth-child(2) {
            width: 910px;
            height: 910px;
            // width: 99vw;
            // background: #bfc;
            border-radius: 50%;
            // transform: translateY(-58%) scale(2.1);
            animation: range2 6s linear infinite;
          }

          @keyframes range2 {
            from {
              transform: translateY(-58%) scale(2.1) rotate(0);
            }

            to {
              transform: translateY(-58%) scale(2.1) rotate(360deg);
            }
          }

          :nth-child(3) {
            width: 758px;
            height: 758px;
            // width: 75vw;
            // background: #08366a;
            border-radius: 50%;
            // transform: translateY(-51%) scale(1.8);
            animation: range3 6s linear infinite;
          }

          @keyframes range3 {
            from {
              transform: translateY(-51%) scale(1.8) rotate(0);
            }

            to {
              transform: translateY(-51%) scale(1.8) rotate(360deg);
            }
          }

          :nth-child(4) {
            width: 700px;
            height: 700px;
            // width: 75vw;
            // background: #b4cdff;
            border-radius: 50%;
            // transform: translateY(-54%) scale(1.8);
            animation: range4 32s linear infinite;
          }

          @keyframes range4 {
            from {
              transform: translateY(-54%) scale(1.8) rotate(0);
            }

            to {
              transform: translateY(-54%) scale(1.8) rotate(360deg);
            }
          }

          :nth-child(5) {
            width: 572px;
            height: 572px;
            // width: 68vw;
            // background: yellow;
            border-radius: 50%;
            // transform: translateY(-65%) scale(1.85);
            animation: range5 6s linear infinite;
          }

          @keyframes range5 {
            from {
              transform: translateY(-65%) scale(1.85) rotate(0);
            }

            to {
              transform: translateY(-65%) scale(1.85) rotate(360deg);
            }
          }

          :nth-child(6) {
            width: 530px;
            height: 530px;
            // width: 60vw;
            // background: aqua;
            border-radius: 50%;
            transform: translateY(-72%) scale(1.7);
            // animation:range5 3s linear infinite;
          }

          @keyframes range6 {
            from {
              transform: translateY(-72%) scale(1.7) rotate(0);
            }

            to {
              transform: translateY(-72%) scale(1.7) rotate(360deg);
            }
          }

          :nth-child(7) {
            width: 530px;
            height: 530px;
            // width: 55vw;
            // background: chocolate;
            border-radius: 50%;
            // transform: translateY(-68%) scale(1.7);
            animation: range7 6s linear infinite;
          }

          @keyframes range7 {
            from {
              transform: translateY(-68%) scale(1.7) rotate(0);
            }

            to {
              transform: translateY(-68%) scale(1.7) rotate(360deg);
            }
          }

          :nth-child(8) {
            width: 410px;
            height: 410px;
            // width: 45vw;
            // background: darkgreen;
            border-radius: 50%;
            // transform: translateY(-82%) scale(1.7);
            animation: range8 6s linear infinite;
          }

          @keyframes range8 {
            from {
              transform: translateY(-82%) scale(1.7) rotate(0);
            }

            to {
              transform: translateY(-82%) scale(1.7) rotate(360deg);
            }
          }

          :nth-child(9) {
            width: 380px;
            height: 380px;
            // width: 40vw;
            // background: floralwhite;
            border-radius: 50%;
            // transform: translateY(-87%) scale(1.8);
            animation: range9 6s linear infinite;
          }

          @keyframes range9 {
            from {
              transform: translateY(-87%) scale(1.8) rotate(0);
            }

            to {
              transform: translateY(-87%) scale(1.8) rotate(360deg);
            }
          }

          :nth-child(10) {
            width: 289px;
            height: 289px;
            border-radius: 50%;
            // transform: translateY(-114%) scale(1.9);
            animation: range10 6s linear infinite;
          }

          @keyframes range10 {
            from {
              transform: translateY(-114%) scale(1.9) rotate(0);
            }

            to {
              transform: translateY(-114%) scale(1.9) rotate(360deg);
            }
          }
        }

        .circleBox {
          width: 100%;
          height: 100%;
          position: relative;
          transform: rotateX(124deg);

          // margin: 0 auto;
          // overflow: hidden;
          .outCircle {
            transform: rotateX(120deg);
            animation: rotate 15s linear infinite;
            width: 1000px;
            height: 1000px;
            transition: all 0.5s ease;
            position: absolute;
            top: 0;
            left: 25%;
          }

          .circle {
            position: absolute;
            animation: overRotate 15s linear infinite;
            width: 800px;
            height: 800px;
            top: -5%;
            transition: all 0.5s linear;
            left: 19%;
          }
        }

      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg) translateZ(0);

      /* 从0度开始 */
    }

    100% {
      transform: rotate(360deg) translateZ(0);

      /* 360度结束 */
    }
  }

  @keyframes overRotate {
    0% {
      transform: rotate(360deg) translateZ(0);

      /* 从0度开始 */
    }

    100% {
      transform: rotate(0deg) translateZ(0);

      /* 360度结束 */
    }
  }

  @keyframes revertRotate {
    0% {
      transform: rotateZ(360deg) translateZ(0);

      /* 从0度开始 */
    }

    100% {
      transform: rotateZ(0deg) translateZ(0);

      /* 360度结束 */
    }
  }

 
  .loginDialog{
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 50%;
    z-index: 9999;
    /deep/.container{
      margin: 0;
      transform: translate(-50%, -50%);
    }

    animation: loginDialogAnima .6s linear;
    animation-fill-mode: forwards;
  }
  
  @keyframes loginDialogAnima {
    0% {
      top: 0%;

      /* 从0度开始 */
    }

    100% {
      top: 50%;

      /* 360度结束 */
    }
  }
}</style>